import React from 'react';
import {AssetServicesProvider} from '../Context/AssetServices/AssetServicesContext';
import {ObserverProvider} from '../Context/Observer/ObserverContext';
import {AssetUploadProvider} from '../Context/Upload/UploadContext';
import ForceLogin from '../ForceLogin/ForceLogin';
import {buildProvidersTree} from '../Providers';
import {DisplayMode} from '@taopix/taopix-design-system';
import {AssistantProvider} from '../Context/Assistant/AssistantContext';
import Assistant from '../Assistant/Assistant';

const AssistantView = () => {
  const AssistantProviderTree = buildProvidersTree([
    [AssetUploadProvider, {}],
    [AssetServicesProvider, {}],
    [ObserverProvider, {}],
    [AssistantProvider, {}],
  ]);

  return (
    <AssistantProviderTree>
      <ForceLogin>
        <Assistant open={true} displayMode={DisplayMode.Fullscreen} />
      </ForceLogin>
    </AssistantProviderTree>
  );
};

export default AssistantView;
